import { render, staticRenderFns } from "./PlaylistCustomTable.vue?vue&type=template&id=197e95e1&scoped=true"
import script from "./PlaylistCustomTable.vue?vue&type=script&lang=js"
export * from "./PlaylistCustomTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197e95e1",
  null
  
)

export default component.exports